import { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, TextField, Table, TableHead, TableRow,
  TableCell, TableBody, Alert, Typography, CircularProgress,
} from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { getTraceability } from '../../api/productieOrdine'
import { errorMessage } from '../../api/client'

export default function OrderTraceabilityDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [lotNumber, setLotNumber] = useState('')
  const mutation = useMutation({ mutationFn: () => getTraceability(lotNumber) })

  const handleClose = () => { setLotNumber(''); mutation.reset(); onClose() }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Trasabilitate lot</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 0.5 }}>
          <Stack direction="row" spacing={1.5}>
            <TextField label="Număr lot" value={lotNumber} onChange={(e) => setLotNumber(e.target.value)} sx={{ flexGrow: 1 }} />
            <Button variant="contained" disabled={!lotNumber || mutation.isPending} onClick={() => mutation.mutate()}
              startIcon={mutation.isPending ? <CircularProgress size={16} color="inherit" /> : undefined}>
              Caută
            </Button>
          </Stack>
          {mutation.isError && <Alert severity="error">{errorMessage(mutation.error)}</Alert>}
          {mutation.isSuccess && mutation.data.operationChain.length > 0 && (
            <>
              <Typography variant="body2" color="text.secondary">
                Lanț de loturi prin operațiile rutei (FR-OPE-028):
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell><TableCell>Operație</TableCell><TableCell>Lot intrare</TableCell><TableCell>Lot ieșire</TableCell>
                    <TableCell align="right">Bun</TableCell><TableCell align="right">Rebut</TableCell><TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mutation.data.operationChain.map((s) => (
                    <TableRow key={s.sequenceOrder}>
                      <TableCell>{s.sequenceOrder}</TableCell>
                      <TableCell>{s.operationName}</TableCell>
                      <TableCell>{s.inputLotNumber ? <code>{s.inputLotNumber}</code> : '—'}</TableCell>
                      <TableCell>{s.outputLotNumber ? <code>{s.outputLotNumber}</code> : '—'}</TableCell>
                      <TableCell align="right">{s.goodQuantity.toFixed(3).replace('.', ',')}</TableCell>
                      <TableCell align="right">{s.scrapQuantity.toFixed(3).replace('.', ',')}</TableCell>
                      <TableCell>{s.status}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
          )}
          {mutation.isSuccess && (mutation.data.operationChain.length === 0 || mutation.data.isFinishedProductLot) && (
            <>
              <Typography variant="body2" color="text.secondary">
                {mutation.data.isFinishedProductLot
                  ? 'Lot de produs finit — loturile de materie primă consumate:'
                  : 'Lot de materie primă — ordinele de producție care l-au consumat și loturile rezultate:'}
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow><TableCell>Lot</TableCell><TableCell>Ordin</TableCell><TableCell align="right">Cantitate</TableCell><TableCell>Data</TableCell></TableRow>
                </TableHead>
                <TableBody>
                  {mutation.data.relatedMovements.map((m, i) => (
                    <TableRow key={i}>
                      <TableCell><code>{m.lotNumber}</code></TableCell>
                      <TableCell>{m.productionOrderNumber}</TableCell>
                      <TableCell align="right">{m.quantity}</TableCell>
                      <TableCell>{new Date(m.createdAt).toLocaleString('ro-RO')}</TableCell>
                    </TableRow>
                  ))}
                  {mutation.data.relatedMovements.length === 0 && (
                    <TableRow><TableCell colSpan={4}>Niciun rezultat.</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={handleClose}>Închide</Button>
      </DialogActions>
    </Dialog>
  )
}
